import { type Provider, Type } from '@angular/core';
import { AiChatRequest } from './ai-chat-request';
import { AiChatRequestService } from './ai-chat-request.service';

export function provideCustomAiChatRequestService(useClass: Type<AiChatRequest>): Provider {
    return { provide: AiChatRequestService, useExisting: useClass };
}
